module.exports = "<span [class]=\"normal ? 'currency--normal' : 'currency'\"> <sup>$</sup>{{ integer() }}<sub>.{{ decimal() }}</sub> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/currency/currency.component.html
// module id = ./src/app/shared/components/currency/currency.component.html
// module chunks = 21